const Buttons = [
  {
    code: `DM-IMPORT${process.env.VUE_APP_MODE !== 'production' ? `-${process.env.VUE_APP_MODE.toUpperCase()}` : ''}`.slice(0, 20),
    targetUrl: `${process.env.VUE_APP_URL}/import`,
    title: `Importovat z DM${process.env.VUE_APP_MODE !== 'production' ? ` (${process.env.VUE_APP_MODE})` : ''}`,
    description: 'Importovat faktury z Document Manageru',
    evidence: 'faktura-prijata',
  },
];

export default Buttons;
